var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingBishopPilotAcademy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2055 1812.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #43363f;\n      }\n\n      .cls-3 {\n        fill: #b60f2f;\n      }\n\n      .cls-4 {\n        fill: #20181e;\n      }\n\n      .cls-5 {\n        fill: #b50f2f;\n      }\n\n      .cls-6 {\n        fill: #181217;\n      }\n\n      .cls-7 {\n        fill: #bc0f31;\n      }\n\n      .cls-8 {\n        isolation: isolate;\n      }\n\n      .cls-9 {\n        fill: #574652;\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-13 {\n        fill: #b30f2e;\n      }\n\n      .cls-14 {\n        fill: #b40f2f;\n      }\n\n      .cls-15 {\n        fill: #ba0f30;\n      }\n\n      .cls-16 {\n        fill: #b90f30;\n      }\n\n      .cls-17 {\n        fill: #bb0f30;\n      }\n\n      .cls-18 {\n        fill: #f4143f;\n      }\n\n      .cls-19 {\n        fill: #171216;\n      }\n\n      .cls-20 {\n        fill: #40333c;\n      }\n\n      .cls-21 {\n        fill: #171116;\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1130.33,584.47h-25.65c86.53,0,156.93-74.92,156.93-167s-70.4-167-156.93-167h25.65c86.53,0,156.93,74.91,156.93,167s-70.4,167-156.93,167Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1130.33,644.47h-25.65c-56.98,0-110.54-23.62-150.83-66.49-1.4-1.48-2.77-2.99-4.12-4.51h25.65c1.35,1.52,2.72,3.03,4.12,4.51,40.29,42.88,93.86,66.49,150.83,66.49Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M975.37,261.47h-25.65c1.35-1.52,2.72-3.03,4.12-4.51,40.29-42.88,93.86-66.49,150.83-66.49h25.65c-56.98,0-110.54,23.62-150.83,66.49-1.4,1.48-2.77,2.99-4.12,4.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M936.92,513.47h-25.65c-13.03-29.67-19.91-62.27-19.91-96s6.88-66.33,19.91-96h25.65c-13.03,29.67-19.91,62.27-19.91,96s6.88,66.32,19.91,96Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Game_Layer"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1860.55,
    y: 884.66,
    width: 171.01,
    height: 927.82
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1841.38 0 1670.37 0 1719.01 0 1890.02 0 1841.38 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "2031.56 884.66 1860.55 884.66 1670.37 0 1841.38 0 2031.56 884.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1890.02 0 2077.96 876.33 2078.54 1812.48 2031.56 1812.48 2031.56 884.66 1841.38 0 1890.02 0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1356.96,
    y: 851.3,
    width: 171.01,
    height: 269.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1326.8,
    y: 1119.63,
    width: 171.01,
    height: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1326.8,
    y: 851.31,
    width: 171.01,
    height: 268.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1497.81 850.48 1326.8 850.48 1356.87 850.48 1527.88 850.48 1497.81 850.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1528.09 851.3 1357.08 851.3 1326.8 850.47 1497.81 850.47 1528.09 851.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1326.8,
    y: 850.48,
    width: 171.01,
    height: 0.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "728.2 1120.47 557.19 1120.47 1326.8 1119.63 1497.81 1119.63 728.2 1120.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "698.11 1120.47 527.1 1120.47 557.19 1120.47 728.2 1120.47 698.11 1120.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "698.13 850.48 527.12 850.48 557.19 850.48 728.2 850.48 698.13 850.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "728.2 851.3 557.19 851.3 527.1 850.47 698.11 850.47 728.2 851.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "728.2 850.48 728.2 851.31 728.2 1119.63 728.2 1120.48 698.13 1120.48 698.13 850.48 728.2 850.48"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 527.12,
    y: 850.48,
    width: 171.01,
    height: 270
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1841.36,0l189.76,882.6v929.87H195.33s0-929.62,0-929.62l32.07-150.71L384.63,0h1456.73ZM1527.86,1120.47l.23-269.18-30.28-.82-769.61.82-30.09-.82v270h30.09s769.61-.84,769.61-.84l30.05.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1527.88 850.48 1527.88 851.31 1527.88 1119.63 1527.88 1120.48 1497.81 1120.48 1497.81 1119.63 1497.81 851.31 1497.81 850.48 1527.88 850.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "384.63 0 213.62 0 1670.35 0 1841.36 0 384.63 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "335.99 0 164.98 0 213.62 0 384.63 0 335.99 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "227.41 732.14 56.4 732.14 213.62 0 384.63 0 227.41 732.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "195.33 882.85 24.32 882.85 56.4 732.14 227.41 732.14 195.33 882.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 24.32,
    y: 882.85,
    width: 171.01,
    height: 929.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "147.47 880.06 -23.54 880.06 164.98 0 335.99 0 147.47 880.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: -23.54,
    y: 880.06,
    width: 171.01,
    height: 932.42
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "384.63 0 227.42 732.15 194.46 885.66 194.46 1812.48 147.47 1812.48 147.47 880.06 335.99 0 384.63 0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "852.85 1197.47 716.04 1197.47 697.25 1174.82 834.06 1174.82 852.85 1197.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1664.75 1119.63 1664.75 1174.82 1645.95 1197.47 852.85 1197.47 834.06 1174.82 834.06 1119.63 1664.75 1119.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 697.25,
    y: 1119.63,
    width: 136.81,
    height: 55.19
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "834.06 1119.63 697.25 1119.63 1527.94 1119.63 1664.75 1119.63 834.06 1119.63"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1559.59 396.21 1533.94 396.21 1567.23 321.47 1592.88 321.47 1559.59 396.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "1380.97 513.47 1355.32 513.47 1533.94 396.21 1559.59 396.21 1380.97 513.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1323.74 513.47 1298.08 513.47 1355.32 513.47 1380.97 513.47 1323.74 513.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1285.28 261.47 1259.63 261.47 1656.34 261.47 1681.99 261.47 1285.28 261.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1130.33,584.47h-25.65c19.84,0,38.84-3.94,56.33-11.12h25.65c-17.49,7.18-36.49,11.12-56.33,11.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1186.65,573.35h-25.65c17.35-7.12,33.22-17.44,46.97-30.26h25.65c-13.75,12.82-29.62,23.14-46.97,30.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1233.62,543.09h-25.65c32.85-30.63,53.63-75.59,53.63-125.61,0-92.09-70.4-167-156.93-167h25.65c86.53,0,156.93,74.91,156.93,167,0,50.02-20.78,94.98-53.63,125.61"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "1042.53 417.16 1016.87 417.16 1104.23 364.21 1129.88 364.21 1042.53 417.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1129.88 470.12 1104.23 470.12 1016.87 417.16 1042.53 417.16 1129.88 470.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1129.88 364.21 1217.23 417.16 1129.88 470.12 1042.53 417.16 1129.88 364.21"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1130.33,644.47h-25.65c-56.98,0-110.54-23.62-150.83-66.49-1.4-1.48-2.77-2.99-4.12-4.51h25.65c1.35,1.52,2.72,3.03,4.12,4.51,40.29,42.88,93.86,66.49,150.83,66.49"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M975.37,261.47h-25.65c1.35-1.52,2.72-3.03,4.12-4.51,3.41-3.63,6.91-7.12,10.51-10.47h25.65c-3.59,3.35-7.1,6.84-10.51,10.47-1.4,1.48-2.77,2.99-4.12,4.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M990,246.5h-25.65c18.94-17.65,40.35-31.4,63.36-40.86h25.65c-23.01,9.46-44.42,23.21-63.36,40.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1053.36,205.63h-25.65c24.22-9.96,50.22-15.16,76.97-15.16h25.65c-26.75,0-52.74,5.2-76.97,15.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M936.92,513.47h-25.65c-13.03-29.67-19.91-62.27-19.91-96s6.88-66.33,19.91-96h25.65c-13.03,29.67-19.91,62.27-19.91,96s6.88,66.32,19.91,96"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "879.67 513.47 854.02 513.47 911.27 513.47 936.92 513.47 879.67 513.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "863.68 573.47 838.03 573.47 631.61 437.95 657.26 437.95 863.68 573.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1285.28,261.47h396.71s-78.6,176.48-78.6,176.48l-206.43,135.52h-111.69c-1.35,1.52-2.73,3.03-4.13,4.51-40.28,42.88-93.85,66.49-150.83,66.49s-110.54-23.62-150.83-66.49c-1.4-1.48-2.77-2.99-4.12-4.51h-111.69s-206.42-135.52-206.42-135.52l-78.61-176.48h396.72c1.35-1.52,2.72-3.03,4.12-4.51,40.29-42.88,93.86-66.49,150.83-66.49s110.55,23.62,150.83,66.49c1.4,1.48,2.78,2.99,4.13,4.51ZM1130.33,584.47c86.53,0,156.93-74.92,156.93-167s-70.4-167-156.93-167c-86.53,0-156.93,74.91-156.93,167s70.4,167,156.93,167M936.92,513.47c-13.03-29.67-19.91-62.27-19.91-96s6.88-66.33,19.91-96h-269.14s33.29,74.73,33.29,74.73l178.61,117.26h57.25M1559.59,396.21l33.29-74.73h-269.14c13.02,29.67,19.9,62.27,19.9,96s-6.88,66.32-19.9,96h57.24s178.62-117.26,178.62-117.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "578.65 261.47 553 261.47 949.72 261.47 975.37 261.47 578.65 261.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "657.26 437.95 631.61 437.95 553 261.47 578.65 261.47 657.26 437.95"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 199.66,
    y: 1436.47,
    width: 1841.8,
    height: 181
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 194.53,
    y: 1436.47,
    width: 5.13,
    height: 181
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "199.66 1436.47 194.53 1436.47 2036.33 1436.47 2041.46 1436.47 199.66 1436.47"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingBishopPilotAcademy);
export default __webpack_public_path__ + "static/media/building-bishop-pilot-academy.f9d883dcac32bebff7d537d372c5d291.svg";
export { ForwardRef as ReactComponent };